import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorResidence = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19.312 21.75a2.75 2.75 0 0 0 2.634-3.54l-1.8-6a2.75 2.75 0 0 0-2.634-1.96H15.4a.75.75 0 0 0 0 1.5h2.112a1.25 1.25 0 0 1 1.197.89l1.8 6a1.25 1.25 0 0 1-1.197 1.61H4.688a1.25 1.25 0 0 1-1.197-1.61l.267-.89H8a.75.75 0 0 0 .75-.75v-2.25h2.55a.75.75 0 1 0 0-1.5H8a.75.75 0 0 0-.75.75v2.25H4.208l1.083-3.61a1.25 1.25 0 0 1 1.197-.89H8.73a.75.75 0 0 0 0-1.5H6.488a2.75 2.75 0 0 0-2.634 1.96l-1.8 6a2.75 2.75 0 0 0 2.634 3.54h14.624Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8.1 7.602C8.1 5.38 9.859 3.6 12 3.6s3.9 1.78 3.9 4.002c0 .495-.2 1.127-.566 1.836-.36.698-.852 1.417-1.367 2.07a16.245 16.245 0 0 1-1.467 1.627 6.282 6.282 0 0 1-.5.436 6.282 6.282 0 0 1-.5-.437 16.245 16.245 0 0 1-1.467-1.627c-.516-.652-1.007-1.37-1.367-2.069C8.3 8.73 8.1 8.097 8.1 7.602Zm3.733 6.08.012-.005a.071.071 0 0 1-.012.006Zm.322-.005a.057.057 0 0 1 .012.006l-.012-.006ZM12 2.4c-2.83 0-5.1 2.342-5.1 5.202 0 .776.3 1.61.7 2.386.405.787.945 1.572 1.492 2.263a17.445 17.445 0 0 0 1.58 1.752c.232.222.449.41.632.547.091.067.186.131.278.181a.894.894 0 0 0 .418.119.894.894 0 0 0 .418-.119 2.34 2.34 0 0 0 .277-.181c.184-.137.4-.325.633-.547a17.442 17.442 0 0 0 1.58-1.752c.547-.691 1.087-1.476 1.492-2.263.4-.775.7-1.61.7-2.386 0-2.86-2.27-5.202-5.1-5.202Zm-1.088 5.1a1.088 1.088 0 1 1 2.175 0 1.088 1.088 0 0 1-2.175 0ZM12 5.213a2.288 2.288 0 1 0 0 4.575 2.288 2.288 0 0 0 0-4.575Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorResidence;
